import React from 'react'
import { Container,Image, Row, Col } from "react-bootstrap";


const FaqBanner = () => {
  return (
    <>
        <section className="banner_section-inner packagebnner position-relative">
      <picture className="position-relative">
        <source
          srcSet={"/img/baneer1719164625.jpg"}
          media="(max-width:576px)"
          type="image/jpg"
        />
        <Image src="/img/baneer1719164625.jpg" className="d-block w-100 banner_search" alt="banner"  type="image/jpg" loading="lazy" />
      </picture>
      <div className="banner_searchBox">
        <Container fluid >
        <Row>
          <Col xs={12}>
          <div className="headingBnner_inner">
                <h1 className='mb-0'>
                Frequently Asked Questions
                </h1>
              </div>
          </Col>
        </Row>

        </Container>
      </div>
    </section>
    </>
  )
}

export default FaqBanner